var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable, computed, makeObservable } from 'mobx';
import { computedFn } from 'mobx-utils';
import { parse } from 'query-string';
import { str_replace } from '../../../../../utils/helper/helper_string';
import { memoize } from '../../../../../utils/mobx/decorators/memoize';
import { BrowserAddressBarWithoutReload } from './BrowserAddressBarWithoutReload';
import { BrowserAddressBarUrl } from './BrowserAddressBarUrl';
import { removeHashStringParameter, updateQueryStringParameter } from '../../../../../utils/helper/helper_url';
import { runtime } from '../../../Runtime';
export class BrowserAddressBar {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
        window.addEventListener('popstate', this.browserLocationChangedHandler);
    }
    get addressUrl() {
        return new BrowserAddressBarUrl(this);
    }
    get withoutReload() {
        return new BrowserAddressBarWithoutReload(this);
    }
    browserLocationChangedHandler() {
        this.changedLocationSnapshot = createSnapshot();
    }
    get initialSnapshot() {
        return createSnapshot();
    }
    changedLocationSnapshot;
    get locationSnapshot() {
        return this.changedLocationSnapshot || this.initialSnapshot;
    }
    get browserRuntime() {
        return this.parent;
    }
    get hostnameWithoutSubdomain() {
        return str_replace(['dev.', 'qs.', 'www.'], '', location.host);
    }
    get query() {
        return new Proxy(this, {
            get: (x, key) => {
                if (key === 'q' && !this.queryValueOf(key)) {
                    return this.queryValueOf('questionId');
                }
                return this.queryValueOf(key);
            } /*,
      
                  set: (x, key: keyof TraitRegistryObject, value) => {
                      this.aspect.aspectSetValue.setValue({ key, value });
                      return true;
                  }*/,
        });
    }
    get hash() {
        return new Proxy(this, {
            get: (x, key) => {
                return this.hashValueOf(key);
            },
        });
    }
    get hashRaw() {
        return parse(this.locationSnapshot.hash.substr(1));
    }
    get queryValueOf() {
        return computedFn(key => {
            return mapQueryVariable(key, this.addressUrl.addressBar.addressUrl.current.searchParams.get(key));
        });
    }
    get hashValueOf() {
        return computedFn(key => {
            return mapHashVariable(key, this.hashRaw[key]);
        });
    }
    setQueryParameterQ(questionId) {
        let url = updateQueryStringParameter(window.location.href, 'q', questionId);
        url = removeHashStringParameter(url, 'questionId');
        this.withoutReload.setUrl(url, `Frage ${questionId}`, { questionId });
        this.browserRuntime.app.appCookies.setCookie('q', questionId);
    }
    setQuestionToHashParameter(questionId) {
        if (!runtime.browserRuntime.browserAddressBar.locationSnapshot.hash.includes('content')) {
            window.location.hash = `q=${questionId}`;
        }
        this.browserRuntime.app.appCookies.setCookie('q', questionId);
    }
}
__decorate([
    memoize
], BrowserAddressBar.prototype, "addressUrl", null);
__decorate([
    memoize
], BrowserAddressBar.prototype, "withoutReload", null);
__decorate([
    action.bound
], BrowserAddressBar.prototype, "browserLocationChangedHandler", null);
__decorate([
    memoize
], BrowserAddressBar.prototype, "initialSnapshot", null);
__decorate([
    observable.ref
], BrowserAddressBar.prototype, "changedLocationSnapshot", void 0);
__decorate([
    computed
], BrowserAddressBar.prototype, "locationSnapshot", null);
__decorate([
    memoize
], BrowserAddressBar.prototype, "query", null);
__decorate([
    memoize
], BrowserAddressBar.prototype, "hash", null);
__decorate([
    memoize
], BrowserAddressBar.prototype, "queryValueOf", null);
__decorate([
    memoize
], BrowserAddressBar.prototype, "hashValueOf", null);
function mapQueryVariable(k, v) {
    if (typeof v === 'undefined')
        return undefined;
    if (k === 'q')
        return parseInt(v);
    return v;
}
function mapHashVariable(k, v) {
    if (typeof v === 'undefined')
        return undefined;
    if (k === 'questionId')
        return parseInt(v);
    return v;
}
/* helper functions */
function createSnapshot() {
    const propsToMirror = ['hash', 'host', 'hostname', 'href', 'origin', 'pathname', 'port', 'protocol', 'search'];
    const snapshot = propsToMirror.reduce((snapshot, prop) => {
        snapshot[prop] = window.location[prop];
        return snapshot;
    }, {});
    return snapshot;
}
